<template>
  <div>
    <div class="app-container">
      <el-row :gutter="20">
        <el-col :span="3" :xs="24">
          <div>
            <el-menu
                default-active="999"
            >
              <el-menu-item v-if="hasAllPermission" index="999" @click="getList2(0)">
                <span slot="title">全部</span>
              </el-menu-item>
              <el-menu-item v-for="item in deptOptions"
                            :key="item.id" :index="item.id"
                            @click="getList2(item.name)">
                <span slot="title">{{item.name}}</span>
              </el-menu-item>
            </el-menu>
          </div>
        </el-col>
        <el-col :span="21" :xs="24">
          <el-form :model="search" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
            <el-form-item label="名称" prop="sName">
              <el-input
                  v-model="search"
                  placeholder="请输入名称"
                  clearable
                  @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
            </el-form-item>
          </el-form>
          <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
              <el-button
                  v-if="hasAddPermission"
                  type="primary"
                  plain
                  icon="el-icon-plus"
                  size="mini"
                  @click="handleAdd"
              >新增</el-button>
            </el-col>
            <el-col :span="1.5">
              <el-button
                  v-if="hasUpdatePermission"
                  type="success"
                  plain
                  icon="el-icon-edit"
                  size="mini"
                  :disabled="single"
                  @click="handleUpdate"
              >修改</el-button>
            </el-col>
            <el-col :span="1.5">
              <el-button
                  v-if="hasDelPermission"
                  type="danger"
                  plain
                  icon="el-icon-delete"
                  size="mini"
                  :disabled="multiple"
                  @click="handleDelete2"
              >删除</el-button>
            </el-col>
          </el-row>
          <el-row :gutter="10" class="mb8" style="margin: 20px 0">
            <el-col :span="1.5">

              <el-menu
                  default-active="999"
                  mode="horizontal"
              >
                <el-menu-item index="999" @click="getList3(0)">
                  <span slot="title">全部</span>
                </el-menu-item>
                <el-menu-item v-for="item in platformOptions"
                              :key="item.id" :index="item.id"
                              @click="getList3(item.platform)">
                  <span slot="title">{{item.platform}}</span>
                </el-menu-item>
              </el-menu>
            </el-col>
          </el-row>
          <el-table v-loading="loading"
                    :data="tableList"
                    @selection-change="handleSelectionChange"
                    @sort-change="handleSortChange"
                    :row-class-name="rowClassName"
          >
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column label="平台号名称" align="center" prop="name" :show-overflow-tooltip="true" >
            </el-table-column>
            <el-table-column label="开设日期" align="center" prop="createDate" sortable />
            <el-table-column label="开设平台" align="center" prop="platform" sortable />
            <el-table-column label="账号负责人" align="center" prop="director" />
            <el-table-column label="账号编辑" align="center" prop="administrators" :show-overflow-tooltip="true" />
            <el-table-column label="粉丝数(万)" align="center" prop="fansNum" sortable />
            <el-table-column label="所属单位" align="center" prop="deptName" :show-overflow-tooltip="true" />
            <el-table-column label="新增时间" align="center" prop="createTime" sortable />
            <el-table-column label="更新时间" align="center" prop="updateTime" sortable />
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status ? 'warning' : 'success'">
                  {{ scope.row.status ? '注销' : '在用' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width" min-width="150">
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="text"
                    icon="el-icon-view"
                    @click="getDetail(scope.row)"
                >详情</el-button>
                <el-button
                    v-if="hasUpdatePermission"
                    size="mini"
                    type="text"
                    icon="el-icon-edit"
                    @click="handleUpdate(scope.row)"
                >修改</el-button>
                <el-button
                    v-if="hasDelPermission"
                    size="mini"
                    type="text"
                    icon="el-icon-close"
                    @click="handleStatus(scope.row)"
                >注销</el-button>
                <el-button
                    v-if="hasDelPermission"
                    size="mini"
                    type="text"
                    icon="el-icon-delete"
                    @click="handleDelete(scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="width: 100%; margin: 10px 0">
            <el-pagination
                style="margin-top: 20px;text-align: right"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage4"
                :page-sizes="[5, 10, 15]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
          </div>

          <el-dialog :title="title" :visible.sync="open" width="60%" append-to-body>
            <el-row :gutter="15">
              <el-form ref="form" :model="form"
                       :rules="rules"
                       size="medium"
                       label-width="100px">
                <el-col :span="12">
                  <el-form-item label="开设平台" prop="platform">
                    <el-select v-model="form.platform"
                               placeholder="请选择开设平台"
                               allow-create
                               filterable
                               default-first-option>
                      <el-option
                          v-for="item in platformOptions"
                          :key="item.id"
                          :label="item.platform"
                          :value="item.platform">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="平台号名称" prop="name">
                    <el-input v-model="form.name" placeholder="请输入平台号名称" clearable :style="{width: '75%'}"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="开设日期" prop="createDate">
                    <el-date-picker
                        v-model="form.createDate"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="账号负责人" prop="director">
                    <el-input v-model="form.director" placeholder="请输入账号负责人" clearable :style="{width: '50%'}"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="账号编辑" prop="administrators">
                    <el-input v-model="form.administrators" placeholder="请输入账号编辑" clearable :style="{width: '50%'}"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="所属单位" prop="deptName">
                    <el-select v-model="form.deptName"
                               placeholder="请选择"
                               filterable
                               default-first-option>
                      <el-option
                          v-for="item in deptOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.name">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="粉丝数" prop="fansNum">
                    <el-input v-model="form.fansNum" placeholder="请输入粉丝数" clearable :style="{width: '50%'}"></el-input>
                    <span>万</span>
                  </el-form-item>
                </el-col>
<!--                <el-col :span="12">-->
<!--                  <el-form-item style="display: flex; align-items: center;"  prop="status">-->
<!--                    <el-switch-->
<!--                        v-model="switchValue"-->
<!--                        active-color="#13ce66"-->
<!--                        inactive-color="#ff4949"-->
<!--                        active-text="在用"-->
<!--                        inactive-text="注销"-->
<!--                        active-value="0"-->
<!--                        inactive-value="1">-->
<!--                    </el-switch>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
              </el-form>
            </el-row>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="submitForm">确 定</el-button>
              <el-button @click="cancel">取 消</el-button>
            </div>
          </el-dialog>
        </el-col>
      </el-row>
      <el-dialog
          title="详情"
          :visible.sync="open2"
          v-loading="loading"
          width="50%"
      >
        <p class="detail">平台号名称：{{detail.name}}</p>
        <p class="detail">所在平台：{{detail.platform}}</p>
        <p class="detail">
          <span style="margin-right: 20px">账号负责人：{{detail.director}}</span>
          <span>手机号：{{detail.phone}}</span>
        </p>
        <p class="detail">账号编辑：{{detail.administrators}}</p>
        <p class="detail">粉丝数：{{detail.fansNum}}</p>
        <p class="detail">开设日期：{{detail.createDate}}</p>

        <!-- 文章数折线图 -->
        <div v-if="showArticlesChart" ref="articlesChart" style="width: 100%; height: 200px; margin-bottom: 20px;"></div>

        <!-- 粉丝数折线图 -->
        <div v-if="showFansChart" ref="fansChart" style="width: 100%; height: 200px; margin-bottom: 20px;"></div>

        <!-- 浏览量数折线图 -->
        <div v-if="showViewsChart" ref="viewsChart" style="width: 100%; height: 200px; margin-bottom: 20px;"></div>

        <!-- 点赞数折线图 -->
        <div v-if="showLikesChart" ref="likesChart" style="width: 100%; height: 200px;"></div>

        <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="open2 = false">确 定</el-button>
  </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import axios from "axios";
import request from "@/utils/request";
import * as echarts from 'echarts';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: "HomeView",
  data() {
    return {
      role: '',
      // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      currentPage4: 1,
      pageSize: 10,
      // 总条数
      total: 0,
      directorOptions: [],
      administratorsOptions: [],
      // 简历表格数据
      tableList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      open2: false,
      // 部门
      deptName: undefined,
      deptOptions: [],
      platform: undefined,
      platformOptions: [],
      defaultProps: {
        // children: "children",
        label: "label"
      },
      sortProp: '',
      sortOrder: '',
      // 查询参数
      search: "",
      // 表单参数
      form: {
        id: undefined
      },
      formData: {},
      detail: {},
      info: {},
      showArticlesChart: true,
      showFansChart: true,
      showLikesChart: true,
      showViewsChart: true,
      switchValue: "0",
      // 表单校验
      rules: {
        name: [
          { required: true, message: "名称不能为空", trigger: "change" }
        ],
        platform: [
          { required: true, message: "开设平台不能为空", trigger: "change" }
        ],
        director: [
          { required: true, message: "责任人不能为空", trigger: "change" }
        ],
        deptName: [
          { required: true, message: "单位不能为空", trigger: "change" }
        ],
        fansNum: [
          {
            validator: (rule, value, callback) => {
              const reg = /^\d+(\.\d+)?$/; // 正则表达式，匹配整数或小数
              if (value === undefined || value === null || value === '') {
                // 如果为空，直接通过验证
                callback();
              } else if (!reg.test(value)) {
                callback(new Error("粉丝数量必须为数字或带小数的数字"));
              } else {
                callback(); // 验证通过
              }
            },
            trigger: "change"
          }
        ]
      }
    };
  },
  // computed: {
  //   queryParams() {
  //     console.log(this.$route.query.token)
  //     axios.get("https://test.api.dzplus.dzng.cc/gateway/authorization/manage/user/get/info/by/token?token="+this.$route.query.token).then(res=>{
  //       console.log(res)
  //     })
  //   },
  // },
  mounted() {
    // 禁止右键
    document.addEventListener('contextmenu', this.preventRightClick);
    // 禁止选择
    document.addEventListener('selectstart', this.preventSelection);
  },
  beforeDestroy() {
    // 移除事件监听器，防止内存泄漏
    document.removeEventListener('contextmenu', this.preventRightClick);
    document.removeEventListener('selectstart', this.preventSelection);
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    hasAllPermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_account_all_media') || false;
      // return this.user.funcKeys.includes('data_analysis');
    },
    hasAddPermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_account_add') || false;
    },
    hasDelPermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_account_del') || false;
    },
    hasUpdatePermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_account_update') || false;
    },
  },

  created() {
    // this.$store.dispatch('fetchUser');
    // // this.getUserPermissions();
    // // this.getList();
    // this.getDept();
    // this.getPlatform();
    // this.getDirector();
    // this.getAdministrator();
    this.initData();
  },
  watch: {
    open2(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.drawChart(); // 确保 DOM 渲染完成后再绘制图表
        });
      }
    }
  },
  methods: {
    async initData() {
      await this.$store.dispatch('fetchUser');  // 等待用户数据加载
      await this.getDept();  // 等待部门数据
      this.getList2();  // 最后获取列表
      this.getPlatform();
      this.getDirector();
      this.getAdministrator();
    },
    // 取消按钮
    cancel() {
      this.open = false;
    },
    // async getUserPermissions() {
    //   try {
    //     const res = await axios.get(`https://test.api.dzplus.dzng.cc/gateway/authorization/manage/user/get/info/by/token?token=${this.$route.query.token}`);
    //     this.permissions = res.data.funcKeys || [];
    //   } catch (error) {
    //     console.error("权限获取失败", error);
    //   }
    // },
    preventRightClick(event) {
      event.preventDefault();
    },
    preventSelection(event) {
      event.preventDefault();
    },
    getList(){
      this.loading = true;
      request.get('/pth/getList',{
        params: {
          pageNum: this.currentPage4,
          pageSize: this.pageSize,
          platform: this.platform,
          deptName: this.deptName,
          name: this.search,
          sortProp: this.sortProp,
          sortOrder: this.sortOrder
        }
      }).then(res =>{
        // console.log(res)
        this.tableList = res.data.records
        this.total = res.data.total
        this.loading=false
      })
    },
    getList2(e){
      if (this.deptOptions.length !== 0){
        if (e === 0) {
          this.deptName = '';
        }else if (e !== undefined) {
          this.deptName = e;
        }
        this.currentPage4 = 1;
        this.loading = true;
        request.get('/pth/getList',{
          params: {
            pageNum: this.currentPage4,
            pageSize: this.pageSize,
            platform: this.platform,
            deptName: this.deptName,
            name: this.search,
            sortProp: this.sortProp,
            sortOrder: this.sortOrder
          }
        }).then(res =>{
          this.tableList = res.data.records
          this.total = res.data.total
          this.loading = false;
        })
      }

    },
    getList3(e) {
      if (this.deptOptions.length !== 0) {
        if (e === 0) {
          this.platform = '';
        }else if (e !== undefined) {
          this.platform = e;
        }
        this.currentPage4 = 1;
        this.loading = true;
        request.get('/pth/getList',{
          params: {
            pageNum: this.currentPage4,
            pageSize: this.pageSize,
            platform: this.platform,
            deptName: this.deptName,
            name: this.search,
            sortProp: this.sortProp,
            sortOrder: this.sortOrder
          }
        }).then(res =>{
          this.tableList = res.data.records
          this.total = res.data.total
          this.loading = false;
        })
      }
    },

    handleSizeChange(pageSize){
      this.pageSize = pageSize
      this.getList()
    },
    handleCurrentChange(pageNum) {
      this.currentPage4 = pageNum
      this.getList()
    },
    async getDept() {
      this.loading = true;
      try {
        const res = await  axios.get("/api/dept/getList")
        if (this.hasAllPermission){
          this.deptOptions = res.data;
        }else {
          this.deptOptions = res.data.filter(dept => dept.id === this.user.companyId);
        }

      } catch (error) {
        console.error('获取部门失败', error);
      } finally {
        if (this.deptOptions.length !== 0){
          if (this.deptOptions.length === 1) {
            this.deptName = this.deptOptions[0].name
          }else {
            this.deptName = ''
          }
          this.getList2()
        }
        this.loading = false;
      }
    },
    getPlatform() {
      axios.get("/api/platform/getList").then(res => {
        this.platformOptions = res.data
      })
    },
    getDirector() {
      const type = "责任人"
      axios.get(`/api/roster/list/${type}`)
          .then(response => {
            this.directorOptions = response.data;
          })
    },
    getAdministrator() {
      const type = "账号编辑"
      axios.get(`/api/roster/list/${type}`)
          .then(response => {
            this.administratorsOptions = response.data;
          })
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        name: null,
        director: null,
        administrators: null,
        deptName: null,
        platform: null,
        fansNum: null
      };
      this.resetForm("form");
    },
    isDataEmpty(data) {
      if (!data || data.length === 0) return true;
      return data.every(item => item === 0 || item === null);
    },
    drawChart() {
      // 确保 DOM 已经渲染
      this.$nextTick(() => {
        const data = this.info;
        if (!data || data.length === 0) {
          this.showArticlesChart = false;
          this.showFansChart = false;
          this.showLikesChart = false;
          this.showViewsChart = false;
        } // 确保数据存在

        const timeList = data.map(item => item.time);
        const articlesNumList = data.map(item => item.articlesNum);
        const fansNumList = data.map(item => item.fansNum);
        const likesNumList = data.map(item => item.likesNum);
        const viewsNumList = data.map(item => item.viewsNum);

        // 文章数折线图
        if (!this.isDataEmpty(articlesNumList)) {
          const articlesChartDom = this.$refs.articlesChart;
          if (articlesChartDom) {
            const articlesChart = echarts.init(articlesChartDom);
            articlesChart.setOption({
              title: {
                text: '稿件数量',
                left: 'center'
              },
              tooltip: {
                trigger: 'axis'
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: timeList
              },
              yAxis: {
                min:function(value){
                  return value.min;
                },
                type: 'value',
                minInterval: 1
              },
              series: [
                {
                  name: '稿件数量',
                  type: 'line',
                  data: articlesNumList
                }
              ]
            });
          }
        } else {
          this.showArticlesChart = false; // 不显示文章数折线图
        }

        // 粉丝数折线图
        if (!this.isDataEmpty(fansNumList)) {
          const fansChartDom = this.$refs.fansChart;
          if (fansChartDom) {
            const fansChart = echarts.init(fansChartDom);
            fansChart.setOption({
              title: {
                text: '粉丝数',
                left: 'center'
              },
              tooltip: {
                trigger: 'axis'
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: timeList
              },
              yAxis: {
                min:function(value){
                  return value.min;
                },
                type: 'value',
                minInterval: 1
              },
              series: [
                {
                  name: '粉丝数',
                  type: 'line',
                  data: fansNumList
                }
              ]
            });
          }
        } else {
          this.showFansChart = false; // 不显示粉丝数折线图
        }

        // 点赞数折线图
        if (!this.isDataEmpty(likesNumList)) {
          const likesChartDom = this.$refs.likesChart;
          if (likesChartDom) {
            const likesChart = echarts.init(likesChartDom);
            likesChart.setOption({
              title: {
                text: '点赞数',
                left: 'center'
              },
              tooltip: {
                trigger: 'axis'
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: timeList
              },
              yAxis: {
                min:function(value){
                  return value.min;
                },
                type: 'value',
                minInterval: 1
              },
              series: [
                {
                  name: '点赞数',
                  type: 'line',
                  data: likesNumList
                }
              ]
            });
          }
        } else {
          this.showLikesChart = false; // 不显示点赞数折线图
        }

        if (!this.isDataEmpty(viewsNumList)) {
          const viewsChartDom = this.$refs.viewsChart;
          if (viewsChartDom) {
            const viewsChart = echarts.init(viewsChartDom);
            viewsChart.setOption({
              title: {
                text: '浏览量',
                left: 'center'
              },
              tooltip: {
                trigger: 'axis'
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: timeList
              },
              yAxis: {
                min:function(value){
                  return value.min;
                },
                type: 'value',
                minInterval: 1
              },
              series: [
                {
                  name: '浏览量',
                  type: 'line',
                  data: viewsNumList
                }
              ]
            });
          }
        } else {
          this.showViewsChart = false; // 不显示点赞数折线图
        }
      });
    },
    getDetail(row) {
      this.loading = true;
      this.showArticlesChart = true;
      this.showFansChart = true;
      this.showLikesChart = true;
      this.showViewsChart = true;
      // 深拷贝 row 数据
      this.detail = JSON.parse(JSON.stringify(row));
      if (row.fansNum) {
        this.detail.fansNum = row.fansNum + "万";
      }

      const name = row.director;
      axios.get(`/api/roster/list2/${name}`).then(res => {
        if (res.data[0]) {
          this.detail.phone = res.data[0].phone;
        }
      })
      request.get('/info', {
        params: {
          id: row.id
        }
      }).then(res => {
        this.info = res.data; // 赋值数据
        this.open2 = true; // 打开对话框
        this.drawChart(); // 数据加载完成后绘制图表
      }).finally(() => {
        this.loading = false; // 关闭加载状态
      });
    },
    rowClassName({ row, rowIndex }) {
      const now = new Date();
      let relevantTime;

      if (row.updateTime) {
        relevantTime = new Date(row.updateTime);
      } else {
        relevantTime = new Date(row.createTime);
      }
      const timeDiff = (now - relevantTime) / (1000 * 60 * 60 * 24); // 计算天数差异
      if (row.createTime == null && row.updateTime == null) {
        return  'confirm';
      } else {
        if (timeDiff > 10) {
          return 'row-red';
        }
        return '';
      }
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    handleSortChange({ prop, order }){
      this.sortProp = prop;
      this.sortOrder = order;
      this.getList2();
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.form.id = undefined
      this.form.platform = this.platform
      this.form.deptName = this.deptName
      this.open = true;
      this.title = "添加信息";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      const id = row.id || this.ids;
      // 深拷贝避免引用问题
      this.form = JSON.parse(JSON.stringify(row));
      this.switchValue = this.form.status.toString();
      // 回显多选管理员
      // this.form.administrators = row.administrators ? row.administrators.split(', ') : [];
      this.open = true;
      this.title = "修改信息";
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          // 克隆一份表单数据
          const formData = JSON.parse(JSON.stringify(this.form));
          formData.status = this.switchValue;
          if (formData.createDate) {
            const utcDate = new Date(formData.createDate); // 从表单中获取时间
            // 加上8小时
            utcDate.setHours(utcDate.getHours() + 16);
            formData.createDate = utcDate.toISOString(); // 转换为 ISO 格式字符串
          }
          console.log(formData)
          // 将管理员数组转换成字符串
          // formData.administrators = formData.administrators.join(', ');
          if (formData.id !== undefined) {
            request.put('/pth/update', formData).then(res => {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              this.open = false;
              this.getList2();
            });
          } else {
            request.post('/pth/add', formData).then(response => {
              this.$message({
                message: '添加成功',
                type: 'success'
              });
              this.open = false;
              this.getList2();
            });
          }
        }
      });
    },
    handleQuery() {
      this.getList2()
    },
//     test() {
//       const axios = require('axios');
//       const CryptoJS = require('crypto-js');
//
//       let time = Date.parse(new Date()) / 1000;
//       let parmas = {
//         appid: "d8c46377d83c4f6e",
//         applicationid: "1009",
//         time: time,
//         columnID: "366376",
//         startDate: "2024-9-1",
//         endDate: "2024-10-1"
//         // 其它参数: xxxx,
//       };
//
// // 按键名排序参数
//       let ascArr = Object.keys(parmas).sort();
//
// // 生成签名字符串
//       let signStr = "";
//       let parmasStr = "?";
//       ascArr.forEach((key, index) => {
//         signStr += parmas[key];
//         if (index) {
//           parmasStr += "&";
//         }
//         parmasStr += key + "=" + parmas[key];
//       });
//       signStr += "ed50afc80e054f809df37212487c7133";
//
// // MD5 加密签名字符串
//       let sign = CryptoJS.MD5(signStr).toString(CryptoJS.enc.Hex).toUpperCase();
//
// // 拼接请求字符串
//       parmasStr += '&sign=' + sign;
//       console.log(parmasStr);
//
// // 发送请求
//       axios({
//         url: "/a2/Client1009/ArticleList" + parmasStr,
//         method: 'get',
//         headers: {
//           'Content-Type': 'application/x-www-form-urlencoded'
//         }
//       }).then((res) => {
//         console.log(res.data);
//       }).catch((error) => {
//         console.error(error);
//       });
//
//     },
    handleStatus(row) {
      this.$confirm('是否确定注销', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.put('/pth/update', {
          id: row.id,
          name: row.name,
          director: row.director,
          administrators: row.administrators,
          deptName: row.deptName,
          createTime: row.createTime,
          fansNum: row.fansNum,
          platform: row.platform,
          createDate: row.createDate,
          status: 1,
        }).then(res => {
          this.$message({
            message: '注销成功',
            type: 'success'
          });
          this.open = false;
          this.getList2();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消注销'
        });
      });

    },
    /** 删除按钮操作 */
    handleDelete(row){
      const ids = row.id || this.ids;
      this.$confirm('是否确定删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.delete('/pth/delete/' + ids).then(res=>{
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getList2();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleDelete2() {
      if (this.ids.length === 0) {
        this.$message({
          type: 'info',
          message: '请选择要删除的项'
        });
        return;
      }
      this.$confirm('是否确定删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteBatch(this.ids);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    deleteBatch(ids) {
      request.post('/pth/deleteBatch', ids)
          .then(res => {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getList2(); // 重新获取列表
          })
          .catch(error => {
            console.error(error);
            this.$message({
              type: 'error',
              message: '删除失败'
            });
          });
    }

  }
};
</script>

<style>
/*.img {*/
/*  !* D:\project two\resume-management-ui\public\img *!*/
/*  width: 100px;*/
/*  height: 80px;*/
/*}*/
/*.img-input {*/
/*  position: relative;*/
/*  width: 100px;*/
/*  height: 80px;*/
/*  top: -60px;*/
/*  opacity: 0;*/
/*  cursor: pointer;*/
/*}*/
.box{
  width: 100%;
  padding: 20px 30px 30px 20px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
}
.el-table .row-red {
  background: rgb(255,237,237);
}

.el-table .confirm {
  background: oldlace;
}
.detail {
  font-size: 18px;
}
.el-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
</style>
